<template>
<div class="chapter">
<div class="inner_page">
<p class="colophon"><span>Europa Editions<br/>
 1 Penn Plaza, Suite 6282<br/>
New York, N.Y. 10019<br/>
  info@europaeditions.com<br/>
  www.europaeditions.com<br/>
<br/>
  This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously.<br/>
<br/>
  Copyright © 2021 by Alan Parks<br/>
  First publication 2021 by Europa Editions<br/>
<br/>
  All rights reserved, including the right of reproduction in whole or in part in any form.<br/>
<br/>
  Excerpt from “Fortunate Son.” Words and Music by John Fogerty, <br/>
copyright © 1969 Jondora Music c/o Concord Music Publishing. <br/>
Copyright Renewed. All Rights Reserved. <br/>
Used by Permission of Hal Leonard Europe Limited.<br/>
<br/>
  Cover Art by Emanuele Ragnisco<br/>
  www.mekkanografici.com<br/>
  Cover photo: Shutterstock<br/>
<br/>
  ISBN 9781609456887 <br/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Colophon.vue?186bcc53